import React from "react";
import { CImg } from "@coreui/react";

const sectionTitle = {
  color: "#333333",
  fontSize: "18px",
  fontWeight: "bold",
  marginTop: "28px",
  marginBottom: "10px",
};

const paragraph = {
  color: "#444444",
  fontSize: "14px",
  lineHeight: "1.7",
  marginBottom: "10px",
};

const listItem = {
  color: "#444444",
  fontSize: "14px",
  lineHeight: "1.7",
  marginBottom: "6px",
};

const PrivacyPolicy = () => {
  return (
    <div style={{ background: "#ffffff", minHeight: "100vh" }}>
      <div
        style={{
          maxWidth: "800px",
          margin: "0 auto",
          padding: "40px 20px 60px",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            marginBottom: "10px",
          }}
        >
          <CImg src="/images/logo/LogoWhakaaro.png" width="65" height="70" />
          <h1
            style={{
              color: "#333333",
              fontSize: "26px",
              fontWeight: "bold",
              marginTop: "15px",
            }}
          >
            Privacy Policy
          </h1>
          <span style={{ color: "#888888", fontSize: "13px" }}>
            Last updated: 20 July 2026
          </span>
        </div>

        <p style={paragraph}>
          This Privacy Policy describes how Whakaaro ("we", "us" or "our")
          collects, uses and protects your information when you use the
          Whakaaro mobile applications and website (collectively, the
          "Service"), which let you browse restaurants and stores, place food
          and grocery orders, and have them delivered to you.
        </p>
        <p style={paragraph}>
          By using the Service you agree to the collection and use of
          information in accordance with this policy. If you do not agree with
          this policy, please do not use the Service.
        </p>

        <h2 style={sectionTitle}>1. Information We Collect</h2>
        <ul style={{ paddingLeft: "20px" }}>
          <li style={listItem}>
            <b>Account information:</b> your name, phone number and email
            address, provided when you register or place an order.
          </li>
          <li style={listItem}>
            <b>Delivery information:</b> the delivery addresses you save or
            enter, and any delivery instructions you provide.
          </li>
          <li style={listItem}>
            <b>Location information:</b> with your permission, your device's
            location, used to show nearby restaurants and stores, set your
            delivery address and enable order tracking. Delivery partners'
            locations are collected while they are on an active delivery so
            customers can track their orders.
          </li>
          <li style={listItem}>
            <b>Order information:</b> details of the orders you place,
            including items ordered, order value, payment method and order
            history.
          </li>
          <li style={listItem}>
            <b>Device and usage information:</b> device type, operating
            system, app version and a push-notification token so we can send
            you order updates.
          </li>
        </ul>
        <p style={paragraph}>
          We do not collect or store your card or banking details. Payments
          for orders are made by cash or by other methods settled directly
          with the restaurant, store or delivery partner.
        </p>

        <h2 style={sectionTitle}>2. How We Use Your Information</h2>
        <ul style={{ paddingLeft: "20px" }}>
          <li style={listItem}>To create and manage your account.</li>
          <li style={listItem}>
            To receive, process, deliver and track your orders.
          </li>
          <li style={listItem}>
            To send you order status updates and service messages by push
            notification or SMS.
          </li>
          <li style={listItem}>
            To share your delivery details with the restaurant, store and
            delivery partner fulfilling your order.
          </li>
          <li style={listItem}>
            To provide customer support and resolve issues with orders.
          </li>
          <li style={listItem}>
            To improve the Service, prevent fraud and maintain security.
          </li>
        </ul>

        <h2 style={sectionTitle}>3. Sharing of Information</h2>
        <p style={paragraph}>
          We do not sell your personal information. We share it only as needed
          to run the Service:
        </p>
        <ul style={{ paddingLeft: "20px" }}>
          <li style={listItem}>
            With restaurants, stores and delivery partners, who receive the
            details required to prepare and deliver your order (such as your
            name, phone number, address and order items).
          </li>
          <li style={listItem}>
            With service providers that help us operate the Service, such as
            cloud hosting and Google Firebase (used for push notifications).
          </li>
          <li style={listItem}>
            With authorities, if required by law or to protect our legal
            rights.
          </li>
        </ul>

        <h2 style={sectionTitle}>4. Data Retention</h2>
        <p style={paragraph}>
          We retain your account and order information for as long as your
          account is active or as needed to provide the Service, comply with
          legal obligations, resolve disputes and enforce our agreements.
        </p>

        <h2 style={sectionTitle}>5. Data Security</h2>
        <p style={paragraph}>
          We use reasonable administrative and technical safeguards to protect
          your information, including encrypted connections (HTTPS) and
          authenticated access to your account. However, no method of
          transmission or storage is completely secure, and we cannot
          guarantee absolute security.
        </p>

        <h2 style={sectionTitle}>6. Your Rights and Choices</h2>
        <ul style={{ paddingLeft: "20px" }}>
          <li style={listItem}>
            You can access and update your profile information in the app.
          </li>
          <li style={listItem}>
            You can disable location access or push notifications at any time
            in your device settings; some features may not work without them.
          </li>
          <li style={listItem}>
            You can request deletion of your account and personal data by
            contacting us using the details below. We will delete your data
            unless we are required to keep it by law.
          </li>
        </ul>

        <h2 style={sectionTitle}>7. Children's Privacy</h2>
        <p style={paragraph}>
          The Service is not directed to children under 13, and we do not
          knowingly collect personal information from children under 13. If
          you believe a child has provided us personal information, please
          contact us and we will delete it.
        </p>

        <h2 style={sectionTitle}>8. Changes to This Policy</h2>
        <p style={paragraph}>
          We may update this Privacy Policy from time to time. Changes will be
          posted on this page with an updated "Last updated" date. Continued
          use of the Service after changes means you accept the updated
          policy.
        </p>

        <h2 style={sectionTitle}>9. Contact Us</h2>
        <p style={paragraph}>
          If you have any questions about this Privacy Policy or your data,
          contact us at:
        </p>
        <p style={paragraph}>
          <b>Whakaaro</b>
          <br />
          Email: info@whakaaro.in
        </p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
